<ng-container *ngIf="model">
  <u-icon class="icon" *ngIf="model.icon" [model]="iconModel"></u-icon>
  <span
    #subtitle
    data-cy="search-results-subtitle"
    class="text"
    [innerHTML]="model.text | highlight: highlights:highlightStyle"
    [pTooltip]="subtitleTooltipText"
    tooltipPosition="bottom"
    tooltipStyleClass="u-tooltip"
  ></span>
</ng-container>
